import { defineComponent as _defineComponent } from 'vue'
import ArFilesViewObject = Vertica.LouisPoulsen.Application.Content.Pages.Product.ArFilesViewObject;
import { useTranslations } from '@/core/translate.mixin';
import userAgent from '@/services/userAgent.service';
import { QueryParams } from '@/core';
import IconAr from '@/ui/icons/IconAr.vue';
import QRCodeGenerator from '@/ui/shared/QRCodeGenerator.vue';
import { store } from '@/store';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductViewInAugmentedReality',
  props: {
    arFiles: null
  },
  setup(__props: any) {

const props = __props as {arFiles: ArFilesViewObject}

const isPrivateMode = computed<boolean>(() => store.getters['app/isPrivateMode']);



const { t } = useTranslations();
const route = useRoute();
const router = useRouter();

const fullPath = computed<string>(() => route.fullPath);
const query = computed<{[key: string]: string | string[] }>(() => route.query);

const isIOS: boolean = userAgent.isIOS;
const isAndroid: boolean = userAgent.isAndroid;

const root = ref(null);
const showQRCode = ref<boolean>(false);
const qrLink: string = window.location.href + `&${QueryParams.showInAR}=true`;
const linkTitle = computed<string>(() => showQRCode.value ? t('Pages.ProductDetail.ViewInAr.PopUpCloseOnClick') : '');
const backgroundColor = computed<string>(() => isPrivateMode.value ? '#ffffff' : '#f6f6f6');

onMounted(() => {
    if (query.value[QueryParams.showInAR]) {
        (root.value as HTMLElement).click();
    }
});

function clickOutsideQR(): void {
    if (showQRCode.value) {
        showQRCode.value = false;
    }
}

function setupShowInARMode(): void {
    if (query.value[QueryParams.showInAR]) {
        const newQuery = Object.assign({}, query.value);
        delete newQuery[QueryParams.showInAR];
        router.replace({ query: newQuery });
    }
    if (showQRCode.value) {
        (root.value as HTMLAnchorElement).title = '';
        showQRCode.value = false;
        return;
    }
    if (!(root.value as HTMLAnchorElement).relList.supports('ar')) {
        showQRCode.value = true;
    }
    if (isIOS) {
        const aTag: HTMLAnchorElement = document.createElement('a');
        aTag.href = props.arFiles.usdzFile;
        aTag.rel = 'ar';
        document.body.appendChild(aTag);
        const img: HTMLImageElement = document.createElement('img');
        aTag.appendChild(img);
        aTag.click();
        document.body.removeChild(aTag);
        return;
    }
    if (isAndroid && userAgent.androidVersionNumber >= 9) {
        const linkUrl: URL = new URL('intent://arvr.google.com/scene-viewer/1.0');
        linkUrl.searchParams.append('mode', 'ar_preferred');
        linkUrl.searchParams.append('file', props.arFiles.glbFile);
        linkUrl.hash = '#Intent;scheme=https;' +
                'package=com.google.ar.core;' +
                'action=android.intent.action.VIEW;' +
                'S.browser_fallback_url=' + fullPath.value + ';' +
                'end;';
        const aTag: HTMLAnchorElement = document.createElement('a');
        aTag.href = decodeURI(linkUrl.href);
        aTag.rel = 'ar';
        document.body.appendChild(aTag);
        aTag.click();
        document.body.removeChild(aTag);
    }
}

return { __sfc: true,isPrivateMode, props, t, route, router, fullPath, query, isIOS, isAndroid, root, showQRCode, qrLink, linkTitle, backgroundColor, clickOutsideQR, setupShowInARMode, IconAr, QRCodeGenerator }
}

})